@if (selectedContact && selectedLead) {
  <div class="container">
    <div class="header">
      <img alt="Logo" src="assets/icons/finstral-contacts-logo.svg">
    </div>
    <div class="item">
      <div class="profile-data">
        <div class="title-row">
          <div>
            <div class="name">{{ selectedLead?.Contact?.Title }} {{ selectedLead?.Lead?.Contact?.FirstName }} {{ selectedLead?.Lead?.Contact?.LastName }}</div>
            <div class="contact-type">{{ selectedContact?.ContactTypeText }}</div>
            @if (selectedContact?.JobTitle) {
              <div class="contact-job">{{ selectedContact?.JobTitle }}</div>
            }
          </div>
          <div class="editor-container">
            @if (selectedLead?.Editor.AvatarURL) {
              <img alt="Contact image"
                [src]="selectedLead?.Editor.AvatarURL">
            }
            <div>
              <div class="editor-name">{{ selectedLead?.Editor.FirstName }}</div>
              <div>{{ selectedLead?.Editor.LastName }}</div>
            </div>
          </div>
        </div>
        <div class="contact-row">
          <div class="contact-item">
            <div class="title" fiTranslation="REQUEST_DETAIL_HEADLINE_ADDRESS"></div>
            @if (selectedContact?.Company) {
              <div>{{ selectedContact?.Company }}</div>
            }
            @if (selectedContact?.Address) {
              <div>{{ selectedContact?.Address }}</div>
            }
            @if (selectedContact?.AddressExt) {
              <div>{{ selectedContact?.AddressExt }}</div>
            }
            @if (selectedContact?.ZipCode || selectedContact?.City || selectedContact?.ProvinceText) {
              <div>{{ selectedContact?.ZipCode }} {{ selectedContact?.City }} {{selectedContact?.ProvinceText ? '(' + selectedContact?.ProvinceText +')' : '' }}</div>
            }
            @if (selectedContact?.CountryText) {
              <div>{{ selectedContact?.CountryText }}</div>
            }
            @if (
              !selectedContact?.Address &&
              !selectedContact?.AddressExt &&
              !selectedContact?.ZipCode &&
              !selectedContact?.CountryText &&
              !selectedContact?.CountryText &&
              !selectedContact?.VatNumber &&
              !selectedContact?.Website) {
              <div
              class="info-line"> - </div>
            }
          </div>
          <div class="contact-item longer">
            <div class="title" fiTranslation="REQUEST_DETAIL_HEADLINE_CONTACT"></div>
            @if (selectedContact?.Email && !selectedContact?.Email?.endsWith('@temp.finstral.com')) {
              <div>
                {{ selectedContact?.Email }}
              </div>
            } @else {
              @if (selectedContact?.Email) {
                <span>
                  <span fiTranslation="CONTACT_ERRORMSG_HEADLINE_NO_EMAIL"></span>
                </span>
              }
            }
            @if (selectedContact?.AdditionalEmail && !selectedContact?.AdditionalEmail?.endsWith('@temp.finstral.com')) {
              <span>
                {{ selectedContact?.AdditionalEmail }}
              </span>
            }
            @if (contactPhone) {
              <div>
                {{ contactPhone }}
              </div>
            }
            @if (contactMobile) {
              <div>
                {{ contactMobile }}
              </div>
            }
            @if (contactAdditionalMobile) {
              <div>
                {{ contactAdditionalMobile }}
              </div>
            }
          </div>
          <div class="contact-item">
            <div class="title" fiTranslation="FORM_HEADLINE_LANGUAGE"></div>
            {{ selectedContact?.LanguageText }}
            @if (selectedContact?.Website) {
              <div class="space"></div>
              <div class="title" fiTranslation="REQUEST_CREATE_CONTACT_HEADLINE_WEBSITE"></div>
              {{ selectedContact?.Website }}
            }
          </div>
          <div class="contact-item">
            @if (selectedContact?.VatNumber && !selectedContact?.Anonymized) {
              <div class="title" fiTranslation="REQUEST_CREATE_CONTACT_HEADLINE_VAT"></div>
              {{ selectedContact?.VatNumber }}
              <div class="space"></div>
            }
            @if (selectedContact?.TaxNumber) {
              <div class="title" fiTranslation="REQUEST_CREATE_CONTACT_TAX_NUMBER"></div>
              {{ selectedContact?.TaxNumber }}
            }
          </div>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="contact-data">
        <div class="type-row">
          <img alt="type" [src]="selectedLead?.Lead?.Done ? leadHelper.getClosedAssetImage(selectedLead?.Lead?.LeadTypeId) : leadHelper.getAssetImage(selectedLead?.Lead?.LeadTypeId)">
          <span class="type" [fiTranslation]="titleHelper.getLeadTypeTranslation(selectedLead?.Lead?.LeadTypeId)"></span>
          <span class="date">{{ selectedLead?.Lead?.DateFormattedId }}</span>
        </div>
        <div class="contact-row">
          @if (addressToDisplay) {
            <div class="contact-item">
              <div class="title" fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_PROJECT"></div>
              <div class="icon-text">
                <img src="assets/icons/helmet-check.svg" alt="link">
                <div class="is-html is-html-snippet" [innerHTML]="addressToDisplay"></div>
              </div>
            </div>
          }
          <div class="contact-item">
            <div class="title" fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_STATUS"></div>
            <div>{{ selectedLead?.Lead?.StatusText }}</div>
          </div>
          <div class="contact-item dynamic-width">
            <div class="title" fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_DUE_DATE"></div>
            <fi-lead-status
              [printView]="true"
              [compactView]="true"
              [leadData]="selectedLead">
            </fi-lead-status>
          </div>
        </div>
        @if (isOffer) {
          <div class="contact-row">
            @if (selectedLead?.Lead?.ConstructionTypeId) {
              <div class="contact-item">
                <div class="title" fiTranslation="GENERAL_TEXT_CONSTRUCTION_TYPE"></div>
                <div class="icon-text">
                  <img [src]="getConstructionIconUrl(selectedLead?.Lead?.ConstructionTypeId, true)" alt="link">
                  <span>{{ consultationTypeName }}</span>
                </div>
              </div>
            }
            <div class="contact-item">
              <div class="title" fiTranslation="GENERAL_TEXT_PLANER_KOMPOSITION"></div>
              <div>
                N° {{ extendedProperties?.PLANER_CODE ? extendedProperties?.PLANER_CODE : '_____' }}
              </div>
            </div>
            <div class="contact-item">
              <div class="title" fiTranslation="GENERAL_TEXT_OFFER_AMOUNT"></div>
              <div class="icon-text">
                @if (mainOffer?.Amount !== null && mainOffer?.Amount !== undefined) {
                  <span>{{offerTotal | appCurrency: mainOffer?.CurrencyCode}}</span>
                }
                @if (mainOffer?.Amount === null || mainOffer?.Amount === undefined) {
                  <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_EMPTY_HEADLINE"></span>
                }
              </div>
            </div>
            <div class="contact-item">
              <div class="title" fiTranslation="GENERAL_TEXT_ORDER_AMOUNT"></div>
              <div class="icon-text">
                @if (mainOrder?.Amount !== null && mainOrder?.Amount !== undefined) {
                  <span>{{orderTotal | appCurrency: mainOrder?.CurrencyCode}}</span>
                }
                @if (mainOrder?.Amount === null || mainOrder?.Amount === undefined) {
                  <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER_EMPTY_HEADLINE"></span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    @if (articles?.length) {
      <div class="table-container">
        <div class="table-title" fiTranslation="PRINT_DOCUMENT_HEADLINE_ARTICLE"></div>
        <div class="table">
          <div class="row">
            <div [ngStyle]="articleColumnsWidthWidth" class="head-cell" fiTranslation="PRINT_DOCUMENT_TABLE_HEADER_NUMBER"></div>
            <div class="head-cell" fiTranslation="PRINT_DOCUMENT_TABLE_HEADER_DESCRIPTION"></div>
          </div>
          @for (item of articles; track item) {
            <div class="row">
              <div [ngStyle]="articleColumnsWidthWidth">
                <b>{{ item.Article }}</b>
              </div>
              <div>
                {{ item.Description }}
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (isOffer && (composerOffers?.length || composerOrders?.length)) {
      <div class="tables">
        @if (composerOffers?.length) {
          <div class="table-container">
            <div class="table-title" fiTranslation="Angebote"></div>
            <div class="table">
              <div class="row">
                <div style="width: 115px; min-width: 115px;" class="head-cell" fiTranslation="ALT_TEXT_REQUEST_TYPE_OFFER"></div>
                <div class="head-cell" fiTranslation="REQUEST_DETAIL_HEADER_MENU_VALUE"></div>
                <div style="width: 120px; min-width: 120px;" class="head-cell" fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_STATUS"></div>
              </div>
              @for (item of composerOffers; track item) {
                @if (item.IsMain) {
                  <div class="row">
                    <div style="width: 115px; min-width: 115px;"><b>{{ item.Name }}</b></div>
                    <div >{{ item?.Amount | appCurrency: item?.CurrencyCode}}</div>
                    <div style="width: 120px; min-width: 120px;">
                      @if (existsOfferSubmitAndIsExpired(item)) {
                        <b fiTranslation="REQUEST_DETAIL_HEADER_MENU_MAIN_OFFER_STATUS"></b>
                      }
                      @if (!existsOfferSubmitAndIsExpired(item)) {
                        <b>/</b>
                      }
                    </div>
                  </div>
                }
              }
              @if (hasAlternative) {
                <div class="row">
                  <div class="alternative" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ALTERNATIVES">
                  </div>
                </div>
              }
              @for (item of composerOffers; track item) {
                @if (!item.IsMain) {
                  <div class="row">
                    <div style="width: 115px; min-width: 115px;"><b>{{ item.Name }}</b></div>
                    <div >{{ item?.Amount | appCurrency: item?.CurrencyCode}}</div>
                    <div style="width: 120px; min-width: 120px;">
                      @if (existsOfferSubmitAndIsExpired(item)) {
                        <b fiTranslation="REQUEST_DETAIL_HEADER_MENU_MAIN_OFFER_STATUS"></b>
                      }
                      @if (!existsOfferSubmitAndIsExpired(item)) {
                        <b>/</b>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }
        @if (composerOrders?.length) {
          <div class="table-container">
            <div class="table-title" fiTranslation="Auftrage"></div>
            <div class="table">
              <div class="row">
                <div class="head-cell" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER" style="width: 110px; min-width: 110px;"></div>
                <div class="head-cell" fiTranslation="REQUEST_DETAIL_HEADER_MENU_VALUE"></div>
              </div>
              @for (item of composerOrders; track item) {
                <div class="row">
                  <div style="width: 110px; min-width: 110px;"><b>{{ item.Name }}</b></div>
                  <div>{{ item?.Amount | appCurrency: item?.CurrencyCode}}</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    <div class="table-container">
      <div class="table-title" fiTranslation="PRINT_DOCUMENT_HEADLINE_HISTORY"></div>
      <div class="table">
        <div class="row">
          <div style="width: 140px; min-width: 140px;" class="head-cell" fiTranslation="SEARCH_DATE"></div>
          <div class="head-cell" fiTranslation="PRINT_DOCUMENT_TABLE_HEADER_HISTORY_ENTRIES"></div>
        </div>
        @if (selectedLeadHistory) {
          @for (item of selectedLeadHistory; track item) {
            @for (content of getHistoryContent(item); track content) {
              <div class="row">
                <div style="width: 140px; min-width: 140px;" class="history-cell">
                  <b>{{ item?.CreTs | date: 'dd.MM.yyyy' }}</b>
                </div>
                <div class="history-cell">
                  <div class="first-line" [fiTranslation]="content.firstLine" [replaceKeys]="true"></div>
                  @for (line of content.otherLines; track line) {
                    <div class="second-line" [hasHTMLTags]="true" [fiTranslation]="line" [replaceKeys]="true"></div>
                  }
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
    <div class="footer">
      <img alt="Logo" src="assets/icons/finstral-contacts-logo.svg">
      <span>
        <span fiTranslation="PRINT_DOCUMENT_FOOTER_PRINTDATE"></span> {{ printedOn | date: 'dd.MM.yyyy' }}
      </span>
      <span> {{ selectedLead?.Lead?.DateFormattedId }} </span>
    </div>
  </div>
}
